import React, { useState } from "react"
import PropTypes from "prop-types"

import dsv from "../services/discover_service_view/discover_service_view.scss"
import wwc from "../services/discover_service_view/works_well_card.scss"
import tqad from "./tqa_details.scss"

const Headers = {
  triggers: "Triggers (If this)",
  actions: "Actions (Then that)",
}

const TqaDetails = props => {
  const [showCount, setShowCount] = useState(3)
  const onSeeMore = () => {
    setShowCount(showCount + 3)
  }
  const maxShowCount = Math.max(props.triggers.length, props.actions.length)

  return (
    <>
      <section styleName="tqad.tqa-details dsv.column">
        {["triggers", "actions"]
          .filter(tqa => props[tqa].length)
          .map(tqas => (
            <div key={tqas} styleName="tqad.column">
              <h2 styleName="tqad.title">{Headers[tqas]}</h2>
              <ul styleName="dsv.tqa-list" className="web-applet-cards tqa">
                {props[tqas]
                  .slice(0, showCount)
                  .map(({ url, name, brand_color, image_url }, i) => (
                    <li
                      styleName="tqad.card"
                      className="my-web-applet-card web-applet-card tqa"
                      key={i}
                    >
                      <a
                        className="web-applet-card applet-card-body tqa"
                        styleName="wwc.connect-card tqad.connect-card"
                        style={{ backgroundColor: `#${brand_color}` }}
                        href={url}
                      >
                        <img styleName="tqad.logo" src={image_url} />
                        <div styleName="tqad.content">
                          <span styleName="tqad.title">{name}</span>
                        </div>
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          ))}
      </section>
      {showCount < maxShowCount && (
        <button
          onClick={onSeeMore}
          styleName="tqad.see-more"
          className="button-secondary"
        >
          See more
        </button>
      )}
    </>
  )
}

const tqaShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  module_name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  brand_color: PropTypes.string.isRequired,
})

TqaDetails.propTypes = {
  triggers: PropTypes.arrayOf(tqaShape).isRequired,
  actions: PropTypes.arrayOf(tqaShape).isRequired,
}

export default TqaDetails
